import { render, staticRenderFns } from "./PgaProjectRequirementsReviewDetails.vue?vue&type=template&id=7380f21b&"
import script from "./PgaProjectRequirementsReviewDetails.vue?vue&type=script&lang=ts&"
export * from "./PgaProjectRequirementsReviewDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VLayout,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7380f21b')) {
      api.createRecord('7380f21b', component.options)
    } else {
      api.reload('7380f21b', component.options)
    }
    module.hot.accept("./PgaProjectRequirementsReviewDetails.vue?vue&type=template&id=7380f21b&", function () {
      api.rerender('7380f21b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/business-startups/internal-projects/components/details/sections/PgaProjectRequirementsReviewDetails.vue"
export default component.exports